"use client";

import { c as _c } from "react/compiler-runtime";
import css from "./footer.module.scss";
import { Fragment, useEffect, useState, useMemo } from "react";
import { Footer as FooterData } from "@/sanity/sanity.types";
import GridColumn from "../grid-column/grid-column";
import GridRow from "../grid-row/grid-row";
import { OneTrustModalButton } from "@/components/third-party-scripts/onetrust/onetrust-modal-button";
import Image from "@/components/common/image/image";
import { PortableText } from "next-sanity";
import { usePathname } from "next/navigation";
import BaseLink from "../base-link/base-link";
import InternalLink from "@/components/common/internal-link";
import { getRates, RateData } from "@/services/wizard-service";
import { PRIVACY_CHOICES_LABEL } from "@/data/constants";
import { ImageLoading } from "@/utilities/imageLoading";
const LEARN_DISCLOSURE_EXCLUSIONS = new Set(["cat", "author", "hub"]);
interface IFooterProps {
  data: FooterData;
}
const Footer = props => {
  const $ = _c(46);
  const {
    data
  } = props;
  const {
    bottomRow,
    columns,
    additionalDisclosure,
    legal
  } = data;
  const pathName = usePathname();
  const [rates, setRates] = useState(null);
  let t0;
  if ($[0] !== pathName) {
    t0 = () => {
      if (!pathName) {
        return false;
      }
      const [, root, section, child] = pathName.replace(/\/+$/, "").split("/");
      if (root === "glossary") {
        return Boolean(section);
      }
      if (root !== "learn" || !section || section === "calculators") {
        return false;
      }
      return !(child && LEARN_DISCLOSURE_EXCLUSIONS.has(section));
    };
    $[0] = pathName;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getIsAdditionalDisclosurePath = t0;
  const isAdditionalDisclosurePath = getIsAdditionalDisclosurePath();
  const bottomRowData = [...(bottomRow ?? []), {
    _key: "privacy-choices-link",
    _type: "link",
    label: PRIVACY_CHOICES_LABEL,
    href: "",
    ctaId: "privacy-choices-link",
    ctaValue: "privacy-choices-link-footer",
    nofollow: ""
  }];
  let t1;
  let t2;
  if ($[2] !== pathName) {
    t1 = () => {
      if (pathName === "/today-mortgage-rates") {
        getRates().then(setRates).catch(_temp);
      } else {
        setRates(null);
      }
    };
    t2 = [pathName];
    $[2] = pathName;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  bb0: {
    if (pathName !== "/today-mortgage-rates" || !rates) {
      t3 = legal;
      break bb0;
    }
    const t4 = `${rates.disclosureData?.loanAmount}`;
    const t5 = `${rates?.disclosureData?.creditScore}`;
    const t6 = `${rates?.disclosureData?.ltv}`;
    const t7 = `${rates?.disclosureData?.county}`;
    const t8 = `${rates?.disclosureData?.state}`;
    const t9 = `${rates?.disclosureData?.updatedDate}`;
    const t10 = `${rates?.disclosureData?.updatedDate}`;
    let t11;
    if ($[5] !== legal || $[6] !== t10 || $[7] !== t4 || $[8] !== t5 || $[9] !== t6 || $[10] !== t7 || $[11] !== t8 || $[12] !== t9) {
      const placeholders = {
        "{{loan_amount}}": t4,
        "{{creditScore}}": t5,
        "{{ltv}}": t6,
        "{{county}}": t7,
        "{{state}}": t8,
        "{{update}}": t9,
        "{{updatedDuplicate}}": t10
      };
      const legalCopy = JSON.parse(JSON.stringify(legal));
      t11 = legalCopy.map(block => {
        if (block._type === "block" && Array.isArray(block.children)) {
          return {
            ...block,
            children: block.children.map(child_0 => {
              if (child_0._type === "span" && typeof child_0.text === "string") {
                let updatedText = child_0.text;
                for (const [token, value] of Object.entries(placeholders)) {
                  updatedText = updatedText.replaceAll(token, value);
                }
                return {
                  ...child_0,
                  text: updatedText
                };
              }
              return child_0;
            })
          };
        }
        return block;
      });
      $[5] = legal;
      $[6] = t10;
      $[7] = t4;
      $[8] = t5;
      $[9] = t6;
      $[10] = t7;
      $[11] = t8;
      $[12] = t9;
      $[13] = t11;
    } else {
      t11 = $[13];
    }
    t3 = t11;
  }
  const updatedLegal = t3;
  const handleOneTrustClick = _temp2;
  const t4 = css;
  let t5;
  if ($[14] !== columns) {
    t5 = !!columns && <GridRow className="!gap-[24px]"><GridColumn className="flex flex-col flex-wrap justify-between gap-6 md:flex-row">{columns.map((column, index) => <div key={index}><h4 className={css.footerColumnHeading}>{column.heading}</h4><ul className={`${css.footerColumnList} !gap-[20px] md:!gap-[24px]`}>{column.links?.map((link, linkIndex) => <li key={linkIndex}><BaseLink className={css.footerColumnLink} href={link.href ?? ""} onClick={link.label === PRIVACY_CHOICES_LABEL ? handleOneTrustClick : undefined} data-cta-id={link?.ctaId ?? ""} data-cta-value={link?.ctaValue ?? ""} rel={link?.nofollow}>{link.label}</BaseLink></li>)}</ul><hr className="mb-[8px] mt-[32px] block h-px border-none bg-[#727272] md:hidden" /></div>)}</GridColumn></GridRow>;
    $[14] = columns;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== additionalDisclosure || $[17] !== isAdditionalDisclosurePath || $[18] !== legal || $[19] !== rates || $[20] !== updatedLegal) {
    t6 = (legal && rates || isAdditionalDisclosurePath && additionalDisclosure) && <><GridRow><GridColumn><hr /></GridColumn></GridRow><GridRow><GridColumn><h4 className="font-semibold uppercase">Disclosures</h4></GridColumn><GridColumn><div className="flex flex-col gap-[16px]">{legal && rates ? <PortableText onMissingComponent={_temp3} value={updatedLegal} components={{
              types: {
                undefined: _temp4
              },
              marks: {
                unknownMark: _temp5,
                internalLink: _temp6
              }
            }} /> : <p>{additionalDisclosure}</p>}</div></GridColumn></GridRow></>;
    $[16] = additionalDisclosure;
    $[17] = isAdditionalDisclosurePath;
    $[18] = legal;
    $[19] = rates;
    $[20] = updatedLegal;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <GridRow className="!hidden md:!block"><GridColumn><hr /></GridColumn></GridRow>;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <BaseLink href="https://www.nmlsconsumeraccess.org/" className="whitespace-nowrap !text-[#3bd4ae] !underline" target="_blank" data-cta-id="nmlsconsumeraccess" data-cta-value="nmlsconsumeraccess_footer" rel="nofollow">(www.nmlsconsumeraccess.org)</BaseLink>;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <GridRow><GridColumn>AmeriSave Mortgage Corporation, NMLS ID #1168, {t8}, Equal Housing Lender; Corporate Office: 1200 Altmore Avenue, Building 2, suite 300, Sandy Springs GA. Additional licensing information may be found by clicking here on this "<BaseLink href="/legal/licensing" className="whitespace-nowrap !text-[#3bd4ae] !underline" data-cta-id="addisclosures" data-cta-value="addisclosures_footer">{"Advertising Disclosures & Licensing"}</BaseLink>" link. Not all products and options are available In all states. Terms are subject to change without notice. Some people portrayed are professional models.</GridColumn><GridColumn>By refinancing existing loan(s) and/or consolidating debt(s), your total finance charges may be higher over the life of the loan, may reduce the equity in your home, may extend the term of your debt and/or secure the debt with your property.</GridColumn></GridRow>;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const T0 = GridRow;
  const t10 = bottomRowData?.map(_temp7);
  let t11;
  if ($[25] !== t10) {
    t11 = <GridColumn md={4} lg={6} className="flex items-end md:hidden"><div className={`text-[#3BD4AE] ${css.footerBottomRight}`}>{t10}</div></GridColumn>;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="mb-[20px] mt-[24px] md:mb-[12px] md:mt-0"><Image src="/amerisave-equal-housing-opportunity.svg" alt="Amerisave Equal Housing Opportunity" className="h-10 w-auto desktop:h-12" width={323} height={56} loading={ImageLoading.LAZY} /></div>;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <GridColumn md={4} lg={6}><div className={css.footerBottomLeft}>{t12}<span>© {new Date().getFullYear()} AmeriSave. All rights reserved.</span></div></GridColumn>;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  const T1 = GridColumn;
  const t14 = 4;
  const t15 = 6;
  const t16 = "hidden items-end md:flex";
  const t17 = `text-[#3BD4AE] ${css.footerBottomRight}`;
  const t18 = bottomRowData?.map(_temp8);
  let t19;
  if ($[29] !== t18) {
    t19 = <div className={t17}>{t18}</div>;
    $[29] = t18;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== T1 || $[32] !== t19) {
    t20 = <T1 md={t14} lg={t15} className={t16}>{t19}</T1>;
    $[31] = T1;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== T0 || $[35] !== t11 || $[36] !== t13 || $[37] !== t20) {
    t21 = <T0>{t11}{t13}{t20}</T0>;
    $[34] = T0;
    $[35] = t11;
    $[36] = t13;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== t21 || $[40] !== t4.footer || $[41] !== t5 || $[42] !== t6 || $[43] !== t7 || $[44] !== t9) {
    t22 = <footer className={t4.footer}>{t5}{t6}{t7}{t9}{t21}</footer>;
    $[39] = t21;
    $[40] = t4.footer;
    $[41] = t5;
    $[42] = t6;
    $[43] = t7;
    $[44] = t9;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  return t22;
};
export default Footer;
function _temp(err) {
  return console.error("Failed to fetch rates:", err);
}
function _temp2(event) {
  event.preventDefault();
  const oneTrustButton = document.getElementById("onetrust-button");
  if (oneTrustButton) {
    oneTrustButton.click();
  }
}
function _temp3() {
  return null;
}
function _temp4() {
  return null;
}
function _temp5() {
  return null;
}
function _temp6(t0) {
  const {
    children,
    value: value_0
  } = t0;
  return <InternalLink value={value_0}>{children}</InternalLink>;
}
function _temp7(link_0, index_0) {
  return <Fragment key={link_0._key}>{index_0 !== 0 && <span>|</span>}{link_0?.label?.toLowerCase() === PRIVACY_CHOICES_LABEL.toLowerCase() ? <OneTrustModalButton label={link_0.label} cta-id={link_0?.ctaId ?? ""} cta-value={link_0?.ctaValue ?? ""} /> : <BaseLink href={link_0.href ?? ""} className={css.footerLink} data-cta-id={link_0?.ctaId ?? ""} data-cta-value={link_0?.ctaValue ?? ""} rel={link_0?.nofollow}>{link_0.label}</BaseLink>}</Fragment>;
}
function _temp8(link_1, index_1) {
  return <Fragment key={link_1._key}>{index_1 !== 0 && <span>|</span>}{link_1?.label?.toLowerCase() === PRIVACY_CHOICES_LABEL.toLowerCase() ? <OneTrustModalButton label={link_1.label} cta-id={link_1?.ctaId ?? ""} cta-value={link_1?.ctaValue ?? ""} /> : <BaseLink href={link_1.href ?? ""} className={css.footerLink} data-cta-id={link_1?.ctaId ?? ""} data-cta-value={link_1?.ctaValue ?? ""} rel={link_1?.nofollow}>{link_1.label}</BaseLink>}</Fragment>;
}